export interface DictionaryFuelTypeEntity {
  Id: number | undefined;
  FuelType: string;
}
